import React from 'react';

const Checkbox = ({ checked, onChange, error }) => {
  return (
    <label
      className='checkbox-label'
      style={{ display: 'block', borderColor: error ? 'red' : '#555555' }}
    >
      <input
        className='checkbox'
        type='checkbox'
        checked={checked}
        onChange={onChange}
      />
      <div
        style={checked ? { display: 'block', borderColor: 'black' } : {}}
        className='checked_div'
      />
    </label>
  );
};

export default Checkbox;
